module.exports = __webpack_public_path__ + "img/premium.e98112f2.png";